import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

// Main columns configuration
export const evacuationPlanningColumns = (
  viewModal,
  updateModal,
  deleteRecord
) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Emergency Shelter Locations": [
      {
        title: "Name of Shelter",
        dataIndex: "Name of Shelter",
        key: "name of shelter",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Go Bag Name": [
      {
        title: "Location",
        dataIndex: "Location",
        key: "location",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Contents",
        dataIndex: "Contents",
        key: "contents",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Vehicle Information": [
      {
        title: "Year",
        dataIndex: "Year",
        key: "year",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Make",
        dataIndex: "Make",
        key: "make",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Model",
        dataIndex: "Model",
        key: "model",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Maintenance Status",
        dataIndex: "Maintenance Status",
        key: "maintenancestatus",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
